// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { productDetailsVideosStyles } from "@sc/App/Widgets/ProductDetails/ProductDetailsVideos";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

productDetailsVideosStyles.wrapper = {
    css: css`
        @media print {
            display: none;
        }
    `,
};

productDetailsVideosStyles.title = {
    variant: "h3",
    forwardAs: "p",
    css: css`
        margin-bottom: 12px;
    `,
};

productDetailsVideosStyles.videosContainer = {
    css: css`
        display: flex;
        column-gap: 22px;
        row-gap: 16px;
        flex-wrap: wrap;
        ${xScreen("lte", "md")} {
            column-gap: 20px;
        }
        ${xScreen("lte", 767)} {
            flex-direction: column;
        }
    `,
};

productDetailsVideosStyles.videoContainer = {
    css: css`
        flex-direction: column;
        gap: 12px;
        &&& {
            max-width: 317px;
            ${xScreen("lte", "md")} {
                max-width: 232px;
            }
            ${xScreen("lte", 767)} {
                max-width: 238px;
                height: 185px;
            }
            ${xScreen("lte", "xs")} {
                max-width: 100%;
            }
        }
    `,
};

productDetailsVideosStyles.imageWrapper = {
    css: css`
        position: relative;
        border-radius: 4px;
        overflow: hidden;
        width: 317px;
        height: 179px;

        ${xScreen("lte", "md")} {
            max-width: 232px;
            height: 131px;
        }
        ${xScreen("lte", 767)} {
            max-width: 238px;
            height: 185px;
        }
        ${xScreen("lte", "xs")} {
            max-width: 100%;
        }
    `,
};
